module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enable) ? _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": _vm.modeWidth
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "rules": _vm.rules,
      "label-width": _vm.labelWidth
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_vm._t("default", function() {
    return [_vm._v("请在此设计表单")]
  }, {
    "model": _vm.model
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("用于使表单支持enter提交")])])], 2), _vm._v(" "), (_vm.showFooterBtn) ? _c('div', {
    style: (_vm.textStyle),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.form.resetFields()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交")])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d8e3ff2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalForm.vue
// module id = 661
// module chunks = 114